import * as React from "react"
import Magnifier from "../../../resources/icon/magnifier.png"
import {cn} from "../../lib/utils"

const Input = React.forwardRef(({className, type, ...props}, ref) => {
    return (

        (
            <div className="relative">
                <img src={Magnifier} className="search-magnifier"/>
                <input
                    type={type}
                    placeholder={"통합검색"}
                    className={cn(
                        "flex h-8 w-full border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground outline-none focus-visible focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                        className
                    )}
                    ref={ref}
                    {...props} />
            </div>
        )
    );
})
Input.displayName = "Input"

export {Input}
